export default "/images/47140e2a479ee42a2766ec7e86bb73e3.avif";